import Tab from '@/types/Tab'

export default function (id) {
	return [
		new Tab('content', {
			to: { name: 'integration', params: { integration: id } },
			name: 'Content',
			exact: true,
			value: `/integration/${id}`,
		}),
		new Tab('channels', {
			to: { name: 'integration-child', params: { integration: id, tab: 'channels' } },
			name: 'Channels',
			value: `/integration/${id}/channels`,
		}),
		new Tab('profiles', {
			to: { name: 'integration-child', params: { integration: id, tab: 'profiles' } },
			name: 'Profiles',
			value: `/integration/${id}/profiles`,
		}),
		new Tab('connections', {
			to: { name: 'integration-child', params: { integration: id, tab: 'connections' } },
			name: 'Connections',
			value: `/integration/${id}/connections`,
		}),
		new Tab('mapping', {
			to: { name: 'integration-child', params: { integration: id, tab: 'mapping' } },
			name: 'Mapping',
			value: `/integration/${id}/mapping`,
		}),
		new Tab('logs', {
			to: { name: 'integration-logs', params: { integration: id } },
			name: 'Logs',
			value: `/integration/${id}/logs`,
		}),
	]
}
